export default __webpack_public_path__ + "static/media/T-shirt.480c282e.jpg";